import React from 'react';

const Spinner = () => {
  return (
    <div className='spinner__container'>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Spinner;
